import * as React from "react";
import { formatDate, dateIsInFuture } from "app/utils/filters";
import { ColumnConfig } from "app/components/AppComponents/ConfigurableTable";
import BackOfficeAndSnapminLink from "app/components/BOComponents/BackOfficeAndSnapminLink";

const columnConfigs: ColumnConfig[] = [
  {
    name: "Id",
    render: row => row.id
  },
  {
    name: "Title",
    render: row => {
      return (
        <BackOfficeAndSnapminLink
          backofficeUrl={`/snapscan/ops/user_messaging/${row.id}/summary`}
          snapminUrl={row.snapmin_url}
        >
          {row.title}
        </BackOfficeAndSnapminLink>
      );
    }
  },
  {
    name: "Description",
    render: row => row.description
  },
  {
    name: "Created At",
    render: row => formatDate(row.created_at)
  },
  {
    name: "Updated At",
    render: row => formatDate(row.updated_at)
  },
  {
    name: "Expires At",
    alwaysShow: true,
    render: row => formatDate(row.expires_at)
  },
  {
    name: "Targeting Type",
    render: row => row.user_targeting_type
  },
  {
    name: "Status",
    render: row => {
      if (row.user_targeting_type === "draft") {
        return "Draft";
      } else {
        if (dateIsInFuture(row.expires_at)) {
          return "Published";
        } else {
          return "Expired";
        }
      }
    }
  }
];

export default columnConfigs;
